import { X } from "@phosphor-icons/react";
import { clsx } from "clsx";

import { Tag } from "common/components/ui/Tag";

import { LABEL_COLORS } from "../constants";

import type { Label } from "../types";

type LabelTagProps = { label: Label; size?: "sm" | "md" | "lg" } & (
  | { onClick?: () => void; onRemove?: never }
  | { onClick?: never; onRemove?: () => void }
);
export default function LabelTag({
  label,
  size = "md",
  onClick,
  onRemove,
}: LabelTagProps) {
  const { color, name, id } = label;

  const innerContent = (
    <>
      <div
        className={clsx(
          "-ml-1.5 size-2.5 shrink-0 rounded",
          LABEL_COLORS[color].bgClassName,
        )}
      />
      <span
        className={clsx(
          "overflow-hidden truncate",
          size === "sm" && "max-w-[30ch]",
        )}
      >
        {name}
      </span>
    </>
  );
  return (
    <Tag
      key={id}
      variant="tertiary"
      className="min-w-16 max-w-full shrink"
      size={size}
      asChild={!!onClick}
      rightIcon={
        onRemove && (
          <button
            aria-label={`remove label parameter ${name}`}
            type="button"
            onClick={onRemove}
          >
            <X />
          </button>
        )
      }
    >
      {onClick ? (
        <button
          type="button"
          className="transition-[background] hover:bg-black-100"
          onClick={onClick}
        >
          {innerContent}
        </button>
      ) : (
        innerContent
      )}
    </Tag>
  );
}
